import {
    api_url,
    legendLabelsBoxHeightLine,
    configChartsColorPalettes,
    yRight,
    partSumpTrajectory,
    popupInformation,
    defaultDatalabelsAlign,
    defaultDatalabelsAnchor,
    defaultDatalabelsFontWeight,
    defaultTicksCustomValue,
} from "../../../utils";

const PartBudgetMoyenMobilite = {
    checked: false,
    titleSideBar:
        "Part du budget moyen alloué à la mobilité pour les ménages modestes",
    titleIndicator:
        "SUMP Trajectory Content.charts.PartBudgetMoyenMobilite.title",
    popupInformation: {
        status: "false",
        text: popupInformation[partSumpTrajectory]["partBudgetMoyenMobilite"],
    },
    keyFigure: {
        typeUpdate: "geographical_area", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
    },
    charts: [
        {
            typeChart: "bar",
            typeLabels: "years", // years or geographical_areas
            multiYearGeographicalArea: true,
            singleYearGeographicalAreaType: "year", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
            titleChart: "",
            titleDisplay: "true",
            legendDisplay: "true",
            legendCustom: "false",
            legendLabelsBoxHeight: legendLabelsBoxHeightLine,
            maintainAspectRatio: true,
            indexAxis: "x", // x or y
            heightChart: "300",
            widthChart: "400",
            scales: {
                x: {
                    type: "category",
                    display: true,
                    stacked: false,
                    titleDisplay: false,
                    titleText: "",
                    gridDisplay: false,
                    min: null,
                    beginAtZero: false,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                    },
                },
                y: {
                    type: "linear",
                    display: true,
                    stacked: false,
                    titleDisplay: true,
                    titleText: "",
                    gridDisplay: true,
                    beginAtZero: true,
                    max: 30,
                    ticks: {
                        display: true,
                        value: {
                            prefix: "",
                            suffix: "%",
                        },
                    },
                },
                yRight: yRight,
            },
            annotationsProperties: {
                annotation1: {
                    type: "line",
                    xMin: undefined,
                    xMax: undefined,
                    yMin: 10,
                    yMax: 10,
                    borderColor: "rgb(7, 153, 146)",
                    borderDash: [7, 7],
                    borderWidth: 3,
                },
                annotation2: undefined,
            },
            keyFigure: {
                typeUpdate: "geographical_area", // year or geographical_area
                label: "",
                url: "",
                separator: "",
                position: "",
            },
            datasets: [
                {
                    type: "line",
                    label: "SUMP Trajectory Content.charts.PartBudgetMoyenMobilite.legend.Valeur cible 2040",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=part_budget_moyen_mobilite&trend=projection&chart=part_budget_moyen_mobilite_valeur_cible&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "trajectory_target_value_2040"
                        ].backgroundColor["0"],
                    borderColor:
                        configChartsColorPalettes[
                            "trajectory_target_value_2040"
                        ].borderColor["0"],
                    borderWidth: 3,
                    borderDash: [7, 7],
                    pointStyle: "circle",
                    pointRadius: 0,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: 1,
                    categoryPercentage: 1,
                    datalabelsProperties: {
                        display: false,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        font: {
                            weight: defaultDatalabelsFontWeight,
                        },
                        value: {
                            prefix: "",
                            suffix: "",
                            separator: "",
                        },
                    },
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.PartBudgetMoyenMobilite.legend.< 1000 soles/mes",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=part_budget_moyen_mobilite&trend=projection&chart=part_budget_moyen_mobilite_0_1000&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "trajectory_part_budget_moyen_mobilite"
                        ].backgroundColor["0"],
                    borderColor:
                        configChartsColorPalettes[
                            "trajectory_part_budget_moyen_mobilite"
                        ].borderColor["0"],
                    borderWidth: 2,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 3,
                    tooltipUnit: "%",
                    barPercentage: 0.9,
                    categoryPercentage: 0.9,
                    datalabelsProperties: {
                        display: false,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        font: {
                            weight: defaultDatalabelsFontWeight,
                        },
                        value: {
                            prefix: "",
                            suffix: "%",
                            separator: "",
                        },
                    },
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.PartBudgetMoyenMobilite.legend.De 1000 a 3000 soles/mes",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=part_budget_moyen_mobilite&trend=projection&chart=part_budget_moyen_mobilite_1000_3000&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "trajectory_part_budget_moyen_mobilite"
                        ].backgroundColor["1"],
                    borderColor:
                        configChartsColorPalettes[
                            "trajectory_part_budget_moyen_mobilite"
                        ].borderColor["1"],
                    borderWidth: 2,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 3,
                    tooltipUnit: "%",
                    barPercentage: 0.9,
                    categoryPercentage: 0.9,
                    datalabelsProperties: {
                        display: false,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        font: {
                            weight: defaultDatalabelsFontWeight,
                        },
                        value: {
                            prefix: "",
                            suffix: "%",
                            separator: "",
                        },
                    },
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.PartBudgetMoyenMobilite.legend.De 3000 a 5000 soles/mes",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=part_budget_moyen_mobilite&trend=projection&chart=part_budget_moyen_mobilite_3000_5000&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "trajectory_part_budget_moyen_mobilite"
                        ].backgroundColor["2"],
                    borderColor:
                        configChartsColorPalettes[
                            "trajectory_part_budget_moyen_mobilite"
                        ].borderColor["2"],
                    borderWidth: 2,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 3,
                    tooltipUnit: "%",
                    barPercentage: 0.9,
                    categoryPercentage: 0.9,
                    datalabelsProperties: {
                        display: false,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        font: {
                            weight: defaultDatalabelsFontWeight,
                        },
                        value: {
                            prefix: "",
                            suffix: "%",
                            separator: "",
                        },
                    },
                },
            ],
        },
    ],
};

export default PartBudgetMoyenMobilite;
